import axiosHandler from '@/utils/axios-handler';
import { AxiosResponse } from 'axios';
import { academyApiUrl } from '@/lib/constants/api';

export default async function getUserCourseWithLessons(courseUid: string): Promise<AxiosResponse | null> {
  const baseURL = academyApiUrl(`/v1/users/courses/${courseUid}/lessons`);
  const options = {
    method: 'GET',
    url: baseURL,
    withCredentials: true,
  };
  const response = await axiosHandler(options);
  return response as AxiosResponse;
}
